import { CreatedInterfaces } from '../interfaces';
import { useGetRequest } from './utils/useGetRequest';

const resource = 'balances';

const useGetBalances = (cardId: string) => {
  const [{ data, error, loading: isLoading }] = useGetRequest<CreatedInterfaces<typeof resource>>({
    path: `v1/balances/${cardId}`,
  });

  return {
    balance: {
      date: data?.date,
      data: data?.balances[0],
    },
    isLoading,
    isError: error,
  };
};

export default useGetBalances;
